import { iconNames, type IconName } from 'lucide-react/dynamic';

const iconNameByAlias = new Map<string, IconName>();
for (const name of iconNames) {
  iconNameByAlias.set(name, name);
  iconNameByAlias.set(
    name
      .split('-')
      .map((part) => part[0].toUpperCase() + part.slice(1))
      .join(''),
    name
  );
}

/** Resolves either a Lucide kebab-case name or its React PascalCase export name. */
export const resolveLucideIconName = (name: string): IconName | undefined =>
  iconNameByAlias.get(name);
